var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBtnBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17525 11.4154C6.98022 11.6103 6.71574 11.7198 6.43997 11.7198C6.1642 11.7198 5.89972 11.6103 5.70469 11.4154L1.02469 6.73535C0.829717 6.54032 0.720189 6.27584 0.720189 6.00007C0.720189 5.7243 0.829717 5.45982 1.02469 5.26479L5.70469 0.584791C5.90083 0.395347 6.16354 0.290521 6.43622 0.292891C6.70891 0.29526 6.96975 0.404636 7.16258 0.59746C7.3554 0.790284 7.46478 1.05113 7.46715 1.32381C7.46952 1.5965 7.36469 1.8592 7.17525 2.05535L4.35997 4.96007L14.24 4.96007C14.5158 4.96007 14.7803 5.06964 14.9754 5.26468C15.1704 5.45972 15.28 5.72425 15.28 6.00007C15.28 6.2759 15.1704 6.54042 14.9754 6.73546C14.7803 6.9305 14.5158 7.04007 14.24 7.04007L4.35997 7.04007L7.17525 9.94479C7.37022 10.1398 7.47975 10.4043 7.47975 10.6801C7.47975 10.9558 7.37022 11.2203 7.17525 11.4154Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_181",
    x: -3.27979,
    y: 0.292847,
    width: 22.5598,
    height: 19.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_181",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnBlack);
export default __webpack_public_path__ + "static/media/back_btn_black.4dc070928222dfcd95eda4c3cb196c24.svg";
export { ForwardRef as ReactComponent };